import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import axios from "axios";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import moment from "moment";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../../../assets/css/customersummary.css";
import "jspdf-autotable";

//--------Material React Table------//
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { Box } from "@mui/material";
import { AppContext } from "../../../context/AppContext";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import { checkUserPermission } from "../../../common/UserPermission";

const CustomerContactList = (props) => {

  let PERMISSION_EDIT = "/manage-customers/:id";

  const gridRef = useRef();
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  const { CurrencySymbol, FractionDigits, dateFormate, ReportViewPermission } =
    useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedOption, setSelectedOption] = useState("");

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const [classicView, setClassicView] = useState(true);

  console.log(ReportViewPermission, "ReportViewPermission12311111");
  //---------------------Material React Table------------------//
  // const columns = useMemo(() => [
  //   {
  //     header: "Customer Name",
  //     accessorKey: "Customer",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Full Name",
  //     accessorKey: "FullName",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Email",
  //     accessorKey: "Email",
  //     filterFn: "contains",
  //     size: "100",
  //   },
  //   {
  //     header: "Company Name",
  //     accessorKey: "CompanyName",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Created Date",
  //     accessorKey: "CreateDate",
  //     filterFn: "contains",
  //     size: "150",
  //     Cell: ({ row }) => {
  //       const CreateDate = row?.original?.CreateDate;
  //       if (
  //         CreateDate === "0000-00-00" ||
  //         CreateDate === "" ||
  //         CreateDate === null
  //       ) {
  //         return "";
  //       }
  //       return moment(CreateDate).format("YYYY-MM-DD (HH:mm)");
  //     },
  //   },
  //   {
  //     header: "Created By",
  //     accessorKey: "CreatedBy",
  //     filterFn: "contains",
  //     size: "100",
  //   },
  //   {
  //     header: "Last Modified",
  //     accessorKey: "LastModified",
  //     filterFn: "contains",
  //     size: "150",
  //     Cell: ({ row }) => {
  //       if (row?.original?.LastModified != "") {
  //         return moment(row.original.LastModified).format("MM/DD/YYYY h:mm A");
  //       }
  //     },
  //   },
  //   {
  //     header: "LastModified By",
  //     accessorKey: "LastModifiedBy",
  //     filterFn: "contains",
  //   },
  //   {
  //     header: "Company Name",
  //     accessorKey: "CompanyName",
  //     filterFn: "contains",
  //   },
  //   {
  //     header: "Website",
  //     accessorKey: "Website",
  //     filterFn: "contains",
  //   },
  //   {
  //     header: "Note",
  //     accessorKey: "Note",
  //     filterFn: "contains",
  //   },
  //   {
  //     header: "Billing State",
  //     accessorKey: "BillingState",
  //     filterFn: "contains",
  //     size: "130",
  //   },
  //   {
  //     header: "Shipping Zip",
  //     accessorKey: "ShippingZip",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Billing Zip",
  //     accessorKey: "BillingZip",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Terms",
  //     accessorKey: "Terms",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Customer Type",
  //     accessorKey: "CustomerType",
  //     filterFn: "contains",
  //   },
  //   {
  //     header: "Shipping Country",
  //     accessorKey: "ShippingCountry",
  //     filterFn: "contains",
  //   },
  //   {
  //     header: "Shipping State",
  //     accessorKey: "ShippingState",
  //     filterFn: "contains",
  //   },

  //   {
  //     header: "Billing City",
  //     accessorKey: "BillingCity",
  //     filterFn: "contains",
  //   },
  //   {
  //     header: "Billing Country",
  //     accessorKey: "BillingCountry",
  //     filterFn: "contains",
  //   },
  //   {
  //     header: "Is Deleted",
  //     accessorKey: "Deleted",
  //     filterFn: "contains",
  //   }
  // ]);

  const columns = useMemo(() => [
    {
      header: "Customer full name",
      accessorKey: "Customerfullname",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={(theme) => ({
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "700",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
          })}
          onClick={() =>
            window.open(`/manage-customers/${row.original.CustId}`, "_blank")
          }
        >
          {row.original.CompanyName}
        </Box>
      ),
    },
    {
      header: "Phone",
      accessorKey: "Phone",
      Cell: ({ cell }) => {
        const formatPhoneNumber = (Phone) => {
          const cleaned = ("" + Phone).replace(/\D/g, "");
          const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
          if (match) {
            return `(${match[1]}) ${match[2]}-${match[3]}`;
          }
          return Phone;
        };

        return formatPhoneNumber(cell.getValue());
      },
    },
    {
      header: "Email",
      accessorKey: "Email",
    },
    {
      header: "Full name",
      accessorKey: "Fullname",
    },
    {
      header: "Billing Address",
      accessorKey: "BillingAddress",
      Cell: ({ row }) => {
        return [
          row?.original?.Address1,
          row?.original?.Address2,
          row?.original?.BillingCity,
          row?.original?.BillingState + " " + row?.original?.BillingZZipCode,
          row?.original?.BillingCountry,
        ]
          .filter(Boolean)
          .join(", ");
      },
    },
    {
      header: "Shipping Address",
      accessorKey: "ShippingAddress",
      Cell: ({ row }) => {
        return [
          row?.original?.ShippingAddress1,
          row?.original?.ShippingAddress2,
          row?.original?.Shippingcity,
          row?.original?.Shippingstate + " " + row?.original?.Shippingzipcode,
          row?.original?.Shippingcountry,
        ]
          .filter(Boolean)
          .join(", ");
      },
    },
    {
      header: "Billing Country",
      accessorKey: "BillingCountry",
    },
    {
      header: "Billing City",
      accessorKey: "BillingCity",
    },
    {
      header: "Billing State",
      accessorKey: "BillingState",
    },
    {
      header: "Billing Zip Code",
      accessorKey: "BillingZZipCode",
    },
    {
      header: "Company Name",
      accessorKey: "CompanyName",
    },
    {
      header: "Created By",
      accessorKey: "CreatedBy",
    },
    {
      header: "Created Date",
      accessorKey: "CreatedDate",
      Cell: ({ row }) =>
        moment(row.original.CreatedDate).format(
          `${dateFormate.toUpperCase()} h:mm A`
        ),
    },
    {
      header: "Customer",
      accessorKey: "Customer",
    },
    {
      header: "Customer Type",
      accessorKey: "CustomerType",
    },
    {
      header: "Deleted",
      accessorKey: "Deleted",
    },
    {
      header: "First Name",
      accessorKey: "FirstName",
    },
    {
      header: "Last modified by",
      accessorKey: "Lastmodifiedby",
    },
    {
      header: "Last modified date",
      accessorKey: "Lastmodifieddate",
      Cell: ({ row }) => {
        const lastModifiedDate = row.original.Lastmodifieddate;
        return lastModifiedDate === ""
          ? ""
          : moment(lastModifiedDate).format(
              `${dateFormate.toUpperCase()} h:mm A`
            );
      },
    },
    {
      header: "Last name",
      accessorKey: "Lastname",
    },
    {
      header: "Note",
      accessorKey: "Note",
    },
    {
      header: "Shipping city",
      accessorKey: "Shippingcity",
    },
    {
      header: "Shipping country",
      accessorKey: "Shippingcountry",
    },
    {
      header: "Shipping state",
      accessorKey: "Shippingstate",
    },
    {
      header: "Shipping zip code",
      accessorKey: "Shippingzipcode",
    },
    {
      header: "Terms",
      accessorKey: "Terms",
    },
  ]);


  useEffect(() => {
    localStorage.removeItem("columnVisibility");
  }, []);

  const Classiccolumns = [
    {
      title: "Customer full name",
      field: "Customerfullname",
      headerFilter: "input",
      frozen: true,
      defaultVisible: true,
      formatter: function (cell, formatterParams, onRendered) {
        const rowData = cell.getRow().getData();
        const companyName = rowData.CompanyName;
        const custId = rowData.CustId;
        // Check permission before rendering link
        if (checkUserPermission(PERMISSION_EDIT)) {
          return `<span style="color:#343f62;font-weight:700;text-decoration:underline;cursor:pointer;" onclick="window.open('/manage-customers/${custId}', '_blank')">${companyName}</span>`;
        } else {
          return `<span style="color:#343f62;font-weight:700;">${companyName}</span>`;
        }
      },
    },
    {
      title: "Phone",
      field: "Phone",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Email",
      field: "Email",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Full name",
      field: "Fullname",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Billing Address",
      field: "BillingAddress",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Shipping Address",
      field: "ShippingAddress",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Billing Country",
      field: "BillingCountry",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Billing City",
      field: "BillingCity",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Billing State",
      field: "BillingState",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Billing Zip Code",
      field: "BillingZZipCode",
      headerFilter: "input",
    },
    {
      title: "Company Name",
      field: "CompanyName",
      headerFilter: "input",
    },
    {
      title: "Created By",
      field: "CreatedBy",
      headerFilter: "input",
    },
    {
      title: "Created Date",
      field: "CreatedDate",
      headerFilter: "input",
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Customer",
      field: "Customer",
      headerFilter: "input",
    },
    {
      title: "Customer Type",
      field: "CustomerType",
      headerFilter: "input",
    },
    {
      title: "Deleted",
      field: "Deleted",
      headerFilter: "input",
    },
    {
      title: "First Name",
      field: "FirstName",
      headerFilter: "input",
    },
    {
      title: "Last modified by",
      field: "Lastmodifiedby",
      headerFilter: "input",
    },
    {
      title: "Last modified date",
      field: "Lastmodifieddate",
      headerFilter: "input",
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Last name",
      field: "Lastname",
      headerFilter: "input",
    },
    {
      title: "Note",
      field: "Note",
      headerFilter: "input",
    },
    {
      title: "Shipping city",
      field: "Shippingcity",
      headerFilter: "input",
    },
    {
      title: "Shipping country",
      field: "Shippingcountry",
      headerFilter: "input",
    },
    {
      title: "Shipping state",
      field: "Shippingstate",
      headerFilter: "input",
    },
    {
      title: "Shipping zip code",
      field: "Shippingzipcode",
      headerFilter: "input",
    },
    {
      title: "Terms",
      field: "Terms",
      headerFilter: "input",
    },
    {
      title: "REP",
      field: "REP",
      headerFilter: "input",
    },
    {
      title: "ROUTE",
      field: "ROUTE",
      headerFilter: "input",
    },
    {
      title: "LEVEL",
      field: "LEVEL",
      headerFilter: "input",
    },
    {
      title: "Role Tier",
      field: "RoleTier",
      headerFilter: "input",
    },
  ];

  const apicall = () => {
    console.log(
      JSON.stringify(columnFilters) + " columnFilters | ",
      globalFilter + " globalFilter | ",
      pagination.pageIndex + " pagination.pageIndex | ",
      pagination.pageSize + " pagination.pageSize | ",
      // columnIndex,
      sorting[0]?.id,
      sorting[0]?.desc === undefined
        ? "desc"
        : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
      startdate + " startdate | ",
      enddate + " enddate",
      "api Call payload"
    );

    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    setLoading(true);
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/customercontactlist?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate}&enddate=${enddate}&locationid=${locationid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setSelectedOption(res.data.ResponseData);
          console.log("11", responseData);
          //   barcodeRefs.current = responseData;
        }

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    apicall();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    startdate,
    enddate,
  ]);

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Openingbalance);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Customer Contact List
                </li>
              </ul>
            </div>
          </div>
          <div className="card mt-3" id="print">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  <h6 className="p">SonarPos</h6>
                  <p className="fw-bold p-regular">Customer Contact List</p>
                </div>
              </div>
              <hr />
              <div className="table-responsive">
                <div>
                  {ReportViewPermission == true ? (
                    <button
                      className="btn btn-secondary"
                      onClick={() => setClassicView(!classicView)}
                    >
                      {" "}
                      {classicView ? "Classic View" : "Morden View"}
                    </button>
                  ) : (
                    <></>
                  )}
                  <div>
                    {classicView ? (
                      <CommonTabular
                        Data={responseData}
                        columns={Classiccolumns}
                        Groupvalue={[]}
                        Reportname={"Customer_Contact_List"}
                        frozenRowvalue={0}
                        // layout={"fitDataFill"}
                        Onrefresh={() => apicall()}
                      />
                    ) : (
                      <CommonMatrialReactTable
                        MainHeading="Sonar POS"
                        ReportHeading="Customer Contact List"
                        columns={columns}
                        data={responseData}
                        startdate={startdate}
                        enddate={enddate}
                        columnGrouping={[]}
                        columnsVisibility={{
                          BillingCity: false,
                          BillingState: false,
                          BillingZZipCode: false,
                          CompanyName: false,
                          CreatedBy: false,
                          CreatedDate: false,
                          Customer: false,
                          CustomerType: false,
                          Deleted: false,
                          FirstName: false,
                          Lastmodifiedby: false,
                          Lastmodifieddate: false,
                          Note: false,
                          Lastname: false,
                          Shippingcity: false,
                          Shippingstate: false,
                          Shippingzipcode: false,
                          Terms: false,
                          BillingCountry: false,
                          Shippingcountry: false,
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 text-center"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerContactList;
